import "./shared.css";
import React, { useState, useEffect } from "react";
import { Galleria } from "primereact/galleria";
import { GalleriaService } from "./GalleriaService";

export default function ItemWithoutThumbnailsDemo() {
  const [images, setImages] = useState(null);

  useEffect(() => {
    GalleriaService.getImages().then((data) => setImages(data));
  }, []);

  const itemTemplate = (item) => {
    return (
      <img
        src={item.itemImageSrc}
        alt={item.alt}
        style={{
          width: "40vw",
          display: "block",
          height: "25vw",
        }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  return (
    <div className="card">
      <Galleria
        value={images}
        // numVisible={5}
        circular
        style={{
          maxWidth: "640px",
          maxHeight: "400px",
          boxShadow: " 0 4px 15px #21a8b9",
        }}
        showThumbnails={false}
        item={itemTemplate}
        // thumbnail={thumbnailTemplate}
        autoPlay={true}
      />
    </div>
  );
}
